/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Activate / archive / delete chrome used on custom list pages.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {AppSharedModule} from '../app-shared.module';
import {ObjectStatesComponent} from './object-states.component';
import {ViewObjectStatesComponent} from './view-object-states.component';
import {ConfirmObjectStateModalComponent} from './confirm-object-state-modal.component';

const OBJECT_STATES = [
  ObjectStatesComponent,
  ViewObjectStatesComponent,
  ConfirmObjectStateModalComponent
];

@NgModule({
  imports: [AppSharedModule, FormsModule],
  declarations: OBJECT_STATES,
  exports: OBJECT_STATES
})
export class ObjectStatesModule {
}
